module.exports = __webpack_public_path__ + "static/img/img-3.ef7d124c.png";